// Quotation Internal Review Stage related codes goes here

// NPM Imports
import React, { Fragment } from "react";

// Components Imports
import { QuotationInternalReviewOwnerBtns } from "../QuotationTopBarBtns";

// Declarations

export default function QuotationInternalReviewOwnerStage(props) {
  return (
    <Fragment>
      <div className="document-meta">
        <div
          data-test="quotationtopbarbtns-document-meta"
          className="document-btns">
          <QuotationInternalReviewOwnerBtns {...props} />
        </div>
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationStages/QuotationInternalReviewOwnerStatges.js